export const CUSTOMER_LIST = {
  data: [
    {
      id: 1,
      uuid: "23h72gb72x827xb-23x6tveb728bx7-x37t8",
      organisation_id: 1,
      user_id: 1,
      region_id: 1,
      route_id: 1,
      channel_id: 1,
      user: {
        id: 1,
        firstname: "Bruce",
        lastname: "Wayne"
      }
    },
    {
      id: 2,
      uuid: "78gshvsg-23x6tveb728bx7-x37t8",
      organisation_id: 1,
      user_id: 2,
      region_id: 1,
      route_id: 1,
      channel_id: 1,
      user: {
        id: 2,
        firstname: "Peter",
        lastname: "Parker"
      }
    }
  ]
};
